export const ErrorType = {
  RECAPTCHA: "reCAPTCHA error",
  RECAPTCHA_SCORE: "reCAPTCHA score too low",
  SES: "SES error",
} as const;
